import { render } from "./RenQiPage.vue?vue&type=template&id=60db01c5&scoped=true"
import script from "./RenQiPage.vue?vue&type=script&lang=js"
export * from "./RenQiPage.vue?vue&type=script&lang=js"

import "./RenQiPage.vue?vue&type=style&index=0&id=60db01c5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60db01c5"]])

export default __exports__